module.exports = __webpack_public_path__ + "static/media/config-selected.c579d04e.png";